import { updateBundle } from "../../api/inventoryService";

export const useUpdateBundle = (successCallback) => {
  const update = async (id, data) => {
    try {
        const updatedRecord = await updateBundle(id, data);
        if (successCallback) successCallback(updatedRecord);
        return updatedRecord;
    } catch (error) {
        console.error("Failed to update bundle:", error);
        throw error;
    }
  };

  return { update };
};